"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.climatePositiveGifts = exports.getPlanIdForCouponId = exports.treePlantingGifts = exports.giftIds = exports.giftTypes = void 0;
const plans_1 = require("./plans");
exports.giftTypes = {
    CLIMATE_POSITIVE: 'CLIMATE_POSITIVE',
    TREE_PLANTING: 'TREE_PLANTING',
};
exports.giftIds = {
    CLIMATE_POSITIVE_3_MONTHS: 'climate-positive-gift-3-months',
    CLIMATE_POSITIVE_6_MONTHS: 'climate-positive-gift-6-months',
    CLIMATE_POSITIVE_12_MONTHS: 'climate-positive-gift-12-months',
    TREE_PLANTING_50_TREES: 'tree-planting-gift-50-trees',
    TREE_PLANTING_100_TREES: 'tree-planting-gift-100-trees',
    TREE_PLANTING_2: 'tree-planting-gift-2',
    TREE_PLANTING_3: 'tree-planting-gift-3',
    TREE_PLANTING_100000_TREES: 'tree-planting-gift-100000-trees',
};
exports.treePlantingGifts = {
    [exports.giftIds.TREE_PLANTING_50_TREES]: {
        id: exports.giftIds.TREE_PLANTING_50_TREES,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 50,
        },
    },
    [exports.giftIds.TREE_PLANTING_100_TREES]: {
        id: exports.giftIds.TREE_PLANTING_100_TREES,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 100,
        },
    },
    [exports.giftIds.TREE_PLANTING_2]: {
        id: exports.giftIds.TREE_PLANTING_2,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 250,
        },
    },
    [exports.giftIds.TREE_PLANTING_3]: {
        id: exports.giftIds.TREE_PLANTING_3,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 500,
        },
    },
    [exports.giftIds.TREE_PLANTING_100000_TREES]: {
        id: exports.giftIds.TREE_PLANTING_100000_TREES,
        type: exports.giftTypes.TREE_PLANTING,
        stats: {
            trees: 100000,
        },
    },
};
const couponIdPlanIdMap = {
    '3MONTHSCLIMATEPOSITIVEGBP-v2': plans_1.individualPlansGB['personal-v3-gbp'].id,
    '3MONTHSCLIMATEPOSITIVEUSD-v2': plans_1.individualPlansUS['personal-v3-usd'].id,
    '3MONTHSCLIMATEPOSITIVECAD-v2': plans_1.individualPlansCA['personal-v3-cad'].id,
    '3MONTHSCLIMATEPOSITIVEEUR-v2': plans_1.individualPlansEU['personal-v3-eur'].id,
    '3MONTHSCLIMATEPOSITIVEAUD-v2': plans_1.individualPlansAU['personal-v3-aud'].id,
    '6MONTHSCLIMATEPOSITIVEGBP-v2': plans_1.individualPlansGB['personal-v3-gbp'].id,
    '6MONTHSCLIMATEPOSITIVEUSD-v2': plans_1.individualPlansUS['personal-v3-usd'].id,
    '6MONTHSCLIMATEPOSITIVECAD-v2': plans_1.individualPlansCA['personal-v3-cad'].id,
    '6MONTHSCLIMATEPOSITIVEEUR-v2': plans_1.individualPlansEU['personal-v3-eur'].id,
    '6MONTHSCLIMATEPOSITIVEAUD-v2': plans_1.individualPlansAU['personal-v3-aud'].id,
    '12MONTHSCLIMATEPOSITIVEGBP-v2': plans_1.individualPlansGB['personal-v3-gbp'].id,
    '12MONTHSCLIMATEPOSITIVEUSD-v2': plans_1.individualPlansUS['personal-v3-usd'].id,
    '12MONTHSCLIMATEPOSITIVECAD-v2': plans_1.individualPlansCA['personal-v3-cad'].id,
    '12MONTHSCLIMATEPOSITIVEEUR-v2': plans_1.individualPlansEU['personal-v3-eur'].id,
    '12MONTHSCLIMATEPOSITIVEAUD-v2': plans_1.individualPlansAU['personal-v3-aud'].id,
};
/**
 * This function is used to get the plan id a new user redeeming a coupon gift
 */
const getPlanIdForCouponId = (couponId) => couponIdPlanIdMap[couponId];
exports.getPlanIdForCouponId = getPlanIdForCouponId;
exports.climatePositiveGifts = {
    [exports.giftIds.CLIMATE_POSITIVE_3_MONTHS]: {
        id: exports.giftIds.CLIMATE_POSITIVE_3_MONTHS,
        couponIds: {
            GBP: '3MONTHSCLIMATEPOSITIVEGBP-v2',
            USD: '3MONTHSCLIMATEPOSITIVEUSD-v2',
            CAD: '3MONTHSCLIMATEPOSITIVECAD-v2',
            EUR: '3MONTHSCLIMATEPOSITIVEEUR-v2',
            AUD: '3MONTHSCLIMATEPOSITIVEAUD-v2',
        },
        type: exports.giftTypes.CLIMATE_POSITIVE,
        stats: {
            months: 3,
        },
    },
    [exports.giftIds.CLIMATE_POSITIVE_6_MONTHS]: {
        id: exports.giftIds.CLIMATE_POSITIVE_6_MONTHS,
        couponIds: {
            GBP: '6MONTHSCLIMATEPOSITIVEGBP-v2',
            USD: '6MONTHSCLIMATEPOSITIVEUSD-v2',
            CAD: '6MONTHSCLIMATEPOSITIVECAD-v2',
            EUR: '6MONTHSCLIMATEPOSITIVEEUR-v2',
            AUD: '6MONTHSCLIMATEPOSITIVEAUD-v2',
        },
        type: exports.giftTypes.CLIMATE_POSITIVE,
        stats: {
            months: 6,
        },
    },
    [exports.giftIds.CLIMATE_POSITIVE_12_MONTHS]: {
        id: exports.giftIds.CLIMATE_POSITIVE_12_MONTHS,
        type: exports.giftTypes.CLIMATE_POSITIVE,
        couponIds: {
            GBP: '12MONTHSCLIMATEPOSITIVEGBP-v2',
            USD: '12MONTHSCLIMATEPOSITIVEUSD-v2',
            CAD: '12MONTHSCLIMATEPOSITIVECAD-v2',
            EUR: '12MONTHSCLIMATEPOSITIVEEUR-v2',
            AUD: '12MONTHSCLIMATEPOSITIVEAUD-v2',
        },
        stats: {
            months: 12,
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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